"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.climatePositiveGifts = exports.getPlanIdForCouponId = exports.treePlantingGifts = exports.giftIds = exports.giftTypes = void 0;
const plans_1 = require("./plans");
exports.giftTypes = {
    CLIMATE_POSITIVE: 'CLIMATE_POSITIVE',
    TREE_PLANTING: 'TREE_PLANTING',
};
exports.giftIds = {
    CLIMATE_POSITIVE_3_MONTHS: 'climate-positive-gift-3-months',
    CLIMATE_POSITIVE_6_MONTHS: 'climate-positive-gift-6-months',
    CLIMATE_POSITIVE_12_MONTHS: 'climate-positive-gift-12-months',
    TREE_PLANTING_50_TREES: 'tree-planting-gift-50-trees',
    TREE_PLANTING_100_TREES: 'tree-planting-gift-100-trees',
    TREE_PLANTING_2: 'tree-planting-gift-2',
    TREE_PLANTING_3: 'tree-planting-gift-3',
    TREE_PLANTING_100000_TREES: 'tree-planting-gift-100000-trees',
};
exports.treePlantingGifts = {
    [exports.giftIds.TREE_PLANTING_50_TREES]: {
        id: exports.giftIds.TREE_PLANTING_50_TREES,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 50,
        },
    },
    [exports.giftIds.TREE_PLANTING_100_TREES]: {
        id: exports.giftIds.TREE_PLANTING_100_TREES,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 100,
        },
    },
    [exports.giftIds.TREE_PLANTING_2]: {
        id: exports.giftIds.TREE_PLANTING_2,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 250,
        },
    },
    [exports.giftIds.TREE_PLANTING_3]: {
        id: exports.giftIds.TREE_PLANTING_3,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 500,
        },
    },
    [exports.giftIds.TREE_PLANTING_100000_TREES]: {
        id: exports.giftIds.TREE_PLANTING_100000_TREES,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 100000,
        },
    },
};
const couponIdPlanIdMap = {
    '3MONTHSCLIMATEPOSITIVEGBP-v2': plans_1.individualPlansGB['personal-v3-gbp'].id,
    '3MONTHSCLIMATEPOSITIVEUSD-v2': plans_1.individualPlansUS['personal-v3-usd'].id,
    '3MONTHSCLIMATEPOSITIVECAD-v2': plans_1.individualPlansCA['personal-v3-cad'].id,
    '3MONTHSCLIMATEPOSITIVEEUR-v2': plans_1.individualPlansEU['personal-v3-eur'].id,
    '3MONTHSCLIMATEPOSITIVEAUD-v2': plans_1.individualPlansAU['personal-v3-aud'].id,
    '6MONTHSCLIMATEPOSITIVEGBP-v2': plans_1.individualPlansGB['personal-v3-gbp'].id,
    '6MONTHSCLIMATEPOSITIVEUSD-v2': plans_1.individualPlansUS['personal-v3-usd'].id,
    '6MONTHSCLIMATEPOSITIVECAD-v2': plans_1.individualPlansCA['personal-v3-cad'].id,
    '6MONTHSCLIMATEPOSITIVEEUR-v2': plans_1.individualPlansEU['personal-v3-eur'].id,
    '6MONTHSCLIMATEPOSITIVEAUD-v2': plans_1.individualPlansAU['personal-v3-aud'].id,
    '12MONTHSCLIMATEPOSITIVEGBP-v2': plans_1.individualPlansGB['personal-v3-gbp'].id,
    '12MONTHSCLIMATEPOSITIVEUSD-v2': plans_1.individualPlansUS['personal-v3-usd'].id,
    '12MONTHSCLIMATEPOSITIVECAD-v2': plans_1.individualPlansCA['personal-v3-cad'].id,
    '12MONTHSCLIMATEPOSITIVEEUR-v2': plans_1.individualPlansEU['personal-v3-eur'].id,
    '12MONTHSCLIMATEPOSITIVEAUD-v2': plans_1.individualPlansAU['personal-v3-aud'].id,
};
/**
 * This function is used to get the plan id a new user redeeming a coupon gift
 */
const getPlanIdForCouponId = (couponId) => couponIdPlanIdMap[couponId];
exports.getPlanIdForCouponId = getPlanIdForCouponId;
exports.climatePositiveGifts = {
    [exports.giftIds.CLIMATE_POSITIVE_3_MONTHS]: {
        id: exports.giftIds.CLIMATE_POSITIVE_3_MONTHS,
        couponIds: {
            GBP: '3MONTHSCLIMATEPOSITIVEGBP-v2',
            USD: '3MONTHSCLIMATEPOSITIVEUSD-v2',
            CAD: '3MONTHSCLIMATEPOSITIVECAD-v2',
            EUR: '3MONTHSCLIMATEPOSITIVEEUR-v2',
            AUD: '3MONTHSCLIMATEPOSITIVEAUD-v2',
        },
        type: exports.giftTypes.CLIMATE_POSITIVE,
        stats: {
            months: 3,
        },
    },
    [exports.giftIds.CLIMATE_POSITIVE_6_MONTHS]: {
        id: exports.giftIds.CLIMATE_POSITIVE_6_MONTHS,
        couponIds: {
            GBP: '6MONTHSCLIMATEPOSITIVEGBP-v2',
            USD: '6MONTHSCLIMATEPOSITIVEUSD-v2',
            CAD: '6MONTHSCLIMATEPOSITIVECAD-v2',
            EUR: '6MONTHSCLIMATEPOSITIVEEUR-v2',
            AUD: '6MONTHSCLIMATEPOSITIVEAUD-v2',
        },
        type: exports.giftTypes.CLIMATE_POSITIVE,
        stats: {
            months: 6,
        },
    },
    [exports.giftIds.CLIMATE_POSITIVE_12_MONTHS]: {
        id: exports.giftIds.CLIMATE_POSITIVE_12_MONTHS,
        type: exports.giftTypes.CLIMATE_POSITIVE,
        couponIds: {
            GBP: '12MONTHSCLIMATEPOSITIVEGBP-v2',
            USD: '12MONTHSCLIMATEPOSITIVEUSD-v2',
            CAD: '12MONTHSCLIMATEPOSITIVECAD-v2',
            EUR: '12MONTHSCLIMATEPOSITIVEEUR-v2',
            AUD: '12MONTHSCLIMATEPOSITIVEAUD-v2',
        },
        stats: {
            months: 12,
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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